import { Query } from 'src/core/stores/data-store';
import { AuditLogSummary } from 'src/stores/audit-logs-store';
import DataStoreMock from './base/data-store';
import { AuditLogsMockData } from '../data-sources/audit-logs';

export class AuditLogSummaryStoreMock extends DataStoreMock<AuditLogSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: AuditLogsMockData,
      count: AuditLogsMockData.length,
    });
    return true;
  }

  public async getLogs(query: Partial<Query>) {
    return await this.handleCallAsync(async () => {
      return AuditLogsMockData;
    });
  }
}
